import React from 'react';

import { BuildPath } from  '@/helpers/Paths';
import { LockerFile } from  '@/interfaces/LockerFile';

const accessedStatus = (accessed: boolean) => accessed ? 'Seen' : 'Received';

interface LockerTableRowProps extends LockerFile {
    buttonClick: ()=> void
    className: string
}

const LockerTableRow= ({createDate, filename, accessed, isDeleted, buttonClick, className}: LockerTableRowProps) => (
    <tr className={className}>    
        <td>{new Date(createDate).toLocaleDateString()}</td>
        <td>{filename}</td>
        <td className={accessedStatus(accessed)}>{accessedStatus(accessed)}</td>
        <td className="action-button-container">
            <button aria-label={`${isDeleted ? 'restore' : 'delete'} ${filename}`} className="locker-file-action-button" onClick={buttonClick}>
                <img 
                    alt={`${isDeleted ? 'restore': 'delete'}`}
                    src={`${BuildPath()}/images/icons/${isDeleted ? 'swirl': 'bin'}.svg`}
                />
            </button>
        </td>
    </tr>
)

export default LockerTableRow;